import { render, staticRenderFns } from "./JoinClassroomModal.vue?vue&type=template&id=656d35e1&scoped=true&"
import script from "./JoinClassroomModal.vue?vue&type=script&lang=ts&"
export * from "./JoinClassroomModal.vue?vue&type=script&lang=ts&"
import style0 from "./JoinClassroomModal.vue?vue&type=style&index=0&id=656d35e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d35e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('656d35e1', component.options)
    } else {
      api.reload('656d35e1', component.options)
    }
    module.hot.accept("./JoinClassroomModal.vue?vue&type=template&id=656d35e1&scoped=true&", function () {
      api.rerender('656d35e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/index/JoinClassroomModal.vue"
export default component.exports